import Modal from '../..'
import { forwardRef } from 'react'
import { ModalDescription, ModalTitle, ButtonsWrapper, Button } from '../styles'
export const NoStudyModal = forwardRef(({ close }, ref) => {
  return (
    <Modal ref={ref}>
      <ModalTitle> No hay más estudios pendientes </ModalTitle>
      <ModalDescription>
        No tenemos más estudios pendientes para que informes.
      </ModalDescription>
      <ButtonsWrapper>
        <Button highlighted onClick={close}> Volver </Button>
      </ButtonsWrapper>
    </Modal>
  )
})
